module.exports = __webpack_public_path__ + "img/师宗县人民医院.4e3c7ac7.png";